import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  MyIdentitiesQueryQuery,
  MyIdentitiesQueryQueryVariables
} from "../../../schemaTypes";

export const myIdentitiesQuery = gql`
  query MyIdentitiesQuery(
    $offset: Int!
    $limit: Int!
  ){
    myIdentities(
      offset: $offset, 
      limit: $limit
    ){
      id
      idNumber
      name
      validity
      dob
      gender
      community{
        id
        name
        alias
        logoUrl
        colorCode
      }
      idType
    }
  }
`;

export const newIdentitySubscription = gql`
  subscription NewIdentitySubscription {
    newIdentity{
      id
      photo
      idNumber
      community{
        id
        name
        alias
        logoUrl
        colorCode
        createdAt
        updatedAt
      }
      phoneNumber
      name
      validity
      dob
      gender
      logoUrl
      idType
      address
      createdAt
      updatedAt
    }
  }
`;

export function useMyIdentities(
  variables: MyIdentitiesQueryQueryVariables
) {
  const { data, loading, fetchMore, subscribeToMore } = useQuery<
    MyIdentitiesQueryQuery
  >(
    myIdentitiesQuery,
    { variables }
  );

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newIdentitySubscription,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          myIdentities: [
            ...prev.myIdentities,
            (subscriptionData.data as any).newIdentity
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  const myIdentities = data?.myIdentities ?? [];
  const hasMoreIdentities = myIdentities.length % variables.limit === 0 && myIdentities.length > variables.offset;

  const loadMore = () => {
    fetchMore({
      variables: {
        ...variables,
        offset: myIdentities.length
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          ...prev,
          myIdentities: [
            ...prev.myIdentities,
            ...fetchMoreResult.myIdentities
          ]
        };
      }
    });
  };

  return {
    myIdentities,
    loading,
    loadMore,
    hasMoreIdentities
  };
}